import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core'
import { Map, List } from 'immutable'

@Component({
  selector: 'app-form-builder-option',
  templateUrl: './form-builder-option.component.html',
  styleUrls: ['./form-builder-option.component.css'],
})
export class FormBuilderOptionComponent implements OnInit {
  @Input('isPropertyType') public isPropertyType: boolean
  @Input('option') public option: Map<string, any>
  @Input('parent') public parent: List<Map<string, any>>
  @Input('index') public index: number
  @Output() onAddOption: EventEmitter<any> = new EventEmitter()
  @Output() onDeleteOption: EventEmitter<any> = new EventEmitter()
  @Output() onDeleteRow: EventEmitter<any> = new EventEmitter()
  @Output() onAddInput: EventEmitter<any> = new EventEmitter()
  @Output() onAddSelect: EventEmitter<any> = new EventEmitter()
  @Output() onChangeField: EventEmitter<any> = new EventEmitter()
  @Output() onChangeOptionsOrder: EventEmitter<any> = new EventEmitter()
  constructor() {}

  ngOnInit() {}

  addOption(path = []) {
    this.onAddOption.emit([this.index, 'children', ...path])
  }

  deleteOption(path = []) {
    this.onDeleteOption.emit([this.index, 'children', ...path])
  }

  deleteRow(path = []) {
    this.onDeleteRow.emit([this.index, 'children', ...path])
  }

  addInput(path = []) {
    this.onAddInput.emit([this.index, 'children', ...path])
  }

  addSelect(path = []) {
    this.onAddSelect.emit([this.index, 'children', ...path])
  }

  handleFieldChange({ e, path = [] }) {
    this.onChangeField.emit({ e: e, path: [this.index, 'children', ...path] })
  }

  handleOptionsOrderChange({ option, direction, path = [] }) {
    this.onChangeOptionsOrder.emit({
      option,
      direction,
      path: [this.index, 'children', ...path],
    })
  }
}
